module.exports = __webpack_public_path__ + "static/media/33-3.d6104fb3.mp3";